// Setup stripe lib
const load = require("load-stripe");

if (process.env.STATIC_ASSETS) {
  load.version = '/static/cdn/stripe.js';
}

async function stripeAPI() {
  return load(process.env.STRIPE_KEY);
}

export async function loadStripe() {
  // Pre-load stripe lib
  await stripeAPI();
}

/**
 * Create a Stripe token that server will use later to auth/capture.
 * Note that dollar amount / line items are not needed here.
 *
 * @param {*} payment
 * @param {*} billing_address
 */
export async function createToken(payment, billing_address) {
  // TODO this is not finished
  let stripe = await stripeAPI();
  return stripe.card.createToken({
    number: payment.card_number,
    exp: payment.expiration,
    cvc: payment.cvc,
    name: billing_address.first_name + ' ' + billing_address.last_name,
    address_line1: billing_address.line1,
    address_line2: billing_address.line2,
    address_city: billing_address.city,
    address_state: billing_address.state,
    address_zip: billing_address.postcode,
    address_country: billing_address.country, // Change to EG US?
  });
}



// WEBPACK FOOTER //
// ./src/services/stripe.js